if (!customElements.get('zr-size-guide')) {
  customElements.define('zr-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-guide-open]');
      opener.addEventListener('click', () => dialog.showModal(), options);
      this.querySelector('[data-guide-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } }, options);
      dialog.addEventListener('close', () => opener.focus(), options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('zr-product-information')) {
  customElements.define('zr-product-information', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-panel]')];
      this.panels = [...this.querySelectorAll('[data-information-panel]')];
      this.tablist = this.querySelector('.zr-information-tabs');
      this.selected = this.tabs[0]?.dataset.panel;
      this.media = matchMedia('(min-width: 750px)');
      this.changeMode = () => this.setMode();
      this.media.addEventListener('change', this.changeMode);
      this.tablist.addEventListener('click', event => { const tab = event.target.closest('[data-panel]'); if (tab) this.select(tab.dataset.panel); }, { signal: this.abort.signal });
      this.tablist.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); this.select(this.tabs[next].dataset.panel); this.tabs[next].focus(); }
      }, { signal: this.abort.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data.sectionId !== document.querySelector('product-info')?.dataset.section) return;
          const sku = event.data.variant?.sku || '';
          this.querySelector('[data-variant-sku]').textContent = sku;
          this.querySelector('[data-sku-row]').hidden = !sku;
        });
      }
      this.setMode();
    }
    setMode() {
      const desktop = this.media.matches;
      this.toggleAttribute('data-tabs', desktop);
      this.tablist.hidden = !desktop;
      if (desktop) this.tablist.setAttribute('role', 'tablist'); else this.tablist.removeAttribute('role');
      this.tabs.forEach(tab => {
        if (desktop) { tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', this.panelFor(tab).id); }
        else { tab.removeAttribute('role'); tab.removeAttribute('aria-controls'); tab.removeAttribute('aria-selected'); tab.removeAttribute('tabindex'); }
      });
      this.panels.forEach(details => {
        const panel = details.querySelector('.zr-information-panel');
        if (desktop) { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('tabindex', '0'); panel.setAttribute('aria-labelledby', this.tabs.find(t => t.dataset.panel === details.dataset.informationPanel).id); }
        else { panel.removeAttribute('role'); panel.removeAttribute('tabindex'); panel.removeAttribute('aria-labelledby'); details.open = details.dataset.informationPanel === this.selected; }
      });
      if (desktop) this.select(this.selected);
    }
    panelFor(tab) { return this.panels.find(p => p.dataset.informationPanel === tab.dataset.panel).querySelector('.zr-information-panel'); }
    select(key) {
      this.selected = key;
      this.tabs.forEach(tab => { const active = tab.dataset.panel === key; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      this.panels.forEach(details => { details.open = details.dataset.informationPanel === key; });
    }
    disconnectedCallback() { this.abort?.abort(); this.media?.removeEventListener('change', this.changeMode); this.unsubscribe?.(); }
  });
}
